






































import {computed, defineComponent} from '@vue/composition-api';
import I18nLabel from '@/core/i18n-label/I18nLabel.vue';
import {getModule} from 'vuex-module-decorators';
import {AlertStore} from '@/shared/config/store/alert.store';

export default defineComponent({
    name: 'AlertDialog',
    components: {
        I18nLabel,
    },
    setup() {
        const alertStore: AlertStore = getModule(AlertStore);

        return {
            showDialog: computed(() => alertStore.showDialog),
            type: computed(() => alertStore.type),
            title: computed(() => alertStore.title),
            text: computed(() => alertStore.text),
            confirmKey: computed(() => alertStore.confirmKey),
            aConfirm: alertStore.aConfirm,
            aCancel: alertStore.aCancel,
            confirmButtonColor: computed(() => alertStore.confirmButtonColor),
            confirmButtonLabel: computed(() => alertStore.confirmButtonLabel),
            errors: computed(() => alertStore.errors),
        };
    },
});
